module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "home-page-menu-org"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 content og-bg-light"
  }, [_c('div', {
    staticClass: "align-center"
  }, [_c('span', {
    staticClass: "font-big"
  }, [_vm._v("“ ")]), _vm._v(_vm._s(_vm.$t('message.text.home.intro'))), _c('span', {
    staticClass: "font-big"
  }, [_vm._v(" ”")])])]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true,
      "bootstrap": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 align-center",
    attrs: {
      "role": "main"
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 align-center"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "col-sm-6 align-center animated xFadeInLeft bs-padding-cancel"
  }, [_c('div', {
    staticClass: "home-button home-center-button button-offer",
    on: {
      "click": function($event) {
        _vm.$router.push('/cars')
      }
    }
  }, [_c('div', {
    staticClass: "home-button-wrapper"
  }, [_c('span', {
    staticClass: "button-label"
  }, [_vm._v(_vm._s(_vm.$t('message.title.site.our_cars')))])]), _vm._v(" "), _c('span', {
    staticClass: "label-placeholder"
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 align-center animated xFadeInRight bs-padding-cancel"
  }, [_c('div', {
    staticClass: "home-button home-center-button button-service"
  }, [_c('div', {
    staticClass: "home-button-wrapper"
  }, [_c('span', {
    staticClass: "button-label"
  }, [_vm._v(_vm._s(_vm.$t('message.title.site.services')))])]), _vm._v(" "), _c('span', {
    staticClass: "label-placeholder"
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 align-center animated xFadeInLeft animateDelayed bs-padding-cancel"
  }, [_c('div', {
    staticClass: "home-button home-center-button button-oldtimers-garage"
  }, [_c('div', {
    staticClass: "home-button-wrapper"
  }, [_c('span', {
    staticClass: "button-label"
  }, [_vm._v(_vm._s(_vm.$t('message.title.site.garage')))])]), _vm._v(" "), _c('span', {
    staticClass: "label-placeholder"
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 align-center animated xFadeInRight animateDelayed bs-padding-cancel"
  }, [_c('div', {
    staticClass: "home-button home-center-button button-clubs"
  }, [_c('div', {
    staticClass: "home-button-wrapper"
  }, [_c('span', {
    staticClass: "button-label"
  }, [_vm._v(_vm._s(_vm.$t('message.title.site.club')))])]), _vm._v(" "), _c('span', {
    staticClass: "label-placeholder"
  }, [_vm._v(" ")])])])])]), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true,
      "bootstrap": true
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0beef0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/MenuOrganization.vue
// module id = 1218
// module chunks = 1